angular.module('impactx.tagcloud').directive('ixTagCloud', [function() {
    return {
        scope: {
            height: "=",            // defines the height for the tag cloud panel
            width: "=",             // defines the width for the tag cloud panel
            minFontSize: "=",       // optional (default: 20): defines the minimum font size for the tags
            maxFontSize: "=",       // optional (default: 60): defines the maximum font size for the tags
            timePeriod: "=?"         // optional (default: 3 month): defines the time period in which the search items are considered
        },
        link: function(scope, element, attrs) {
            scope.$watch("timePeriod", function(newValue, oldValue) {
                scope.getPageData();
            });
        },
        templateUrl: 'shared/tagcloud/templates/tagcloud.tmpl.html',
        controller: "TagCloudCtrl",
        transclude: true
    }
}]);

